import { render, staticRenderFns } from "./DashboardCustomizeMessage.vue?vue&type=template&id=9ff70c58&scoped=true"
import script from "./DashboardCustomizeMessage.vue?vue&type=script&lang=ts"
export * from "./DashboardCustomizeMessage.vue?vue&type=script&lang=ts"
import style0 from "./DashboardCustomizeMessage.vue?vue&type=style&index=0&id=9ff70c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff70c58",
  null
  
)

export default component.exports